import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Weeks = styled(Flex).attrs({
  column: true,
  noPrint: true,
})`
  width: 20%;
  min-width: 250px;
  color: #797979;
  border-right: 2px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;
`;

export const WeeksContainer = styled(Flex).attrs({
  width: '100%',
  shrink: '0',
  column: true,
})`
  padding-bottom: 3px;
`;
